
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta } from "/app/pages/faq.vue?macro=true";
import { default as gameQWAwGdPwtLsmyOCjoFmd2yqaforOOa9Vsw_nqU66qYoMeta } from "/app/pages/game.vue?macro=true";
import { default as playgEcQZxWhDCSvLKiTlDUGrDrCPPh74OLQdl5yO4M2w4wMeta } from "/app/pages/play.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as terms1wCL_jcKgXyjae_4516VMbFrKHvZd0F4Waht3oN_MqrwYMeta } from "/app/pages/terms.vue?macro=true";
import { default as searchWiCwPORWRkcZm1zH29UWKNMF4Vb5hM_q5Mi2yI40hlcMeta } from "/app/pages/search.vue?macro=true";
import { default as account8qjjsMH2Z_4583nGmUzgn0GenZn4EgfKFuzSOEohZZlYkMeta } from "/app/pages/account.vue?macro=true";
import { default as profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta } from "/app/pages/profile.vue?macro=true";
import { default as about_45usWFQXpt2DA4_34Qah2UTFFyJ33ypdDo2QsAhRa5cVZQUMeta } from "/app/pages/about-us.vue?macro=true";
import { default as my_45video6jtiIz29PdPWBmi_48X_45Xm313VAScr2zmJHlugvI0foMeta } from "/app/pages/my-video.vue?macro=true";
import { default as registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta } from "/app/pages/register.vue?macro=true";
import { default as bookmarkstsNyEkN6dwH5eavy_45yjgjFgCz_45RF0puU2PyuevLF4U0Meta } from "/app/pages/bookmarks.vue?macro=true";
import { default as _91id_93EyupXKGFR7HQ7rpQDTt0POBBcvsP8E5qU6_tFprmtyIMeta } from "/app/pages/episodes/[id].vue?macro=true";
import { default as _91id_938ex7ayqEWxHJW_GEDU3WKfMu1GqTjEMzybvm7jhUaP8Meta } from "/app/pages/biography/[id].vue?macro=true";
import { default as _91id_93ianvHPXMDaCdakqGppRMQdCEA_457BnlHus677wxGh1sEMeta } from "/app/pages/categories/[id].vue?macro=true";
import { default as indexoxBGzYZqIPKM6NnWsf42sGIx7qvsJK_45xvAxag797X_45YMeta } from "/app/pages/categories/index.vue?macro=true";
import { default as enterWXKdFEabavhx8W9ilXXxSVXeEN_45W4_84oTiBl6z8p9oMeta } from "/app/pages/password/reset/enter.vue?macro=true";
import { default as indexNg5yhSiHRG0mEIOMAjGauMYoEfFsRiy8pNlacXHO2sYMeta } from "/app/pages/password/reset/index.vue?macro=true";
import { default as confirmbY1HL5oC6FT7xikJBIN8L9iCy9bPqydOlwygqi3jsn0Meta } from "/app/pages/password/reset/confirm.vue?macro=true";
import { default as _91id_93P9B7M8rFJxEInwupMlgARyZ_2lD9_l4lSejDiTJ6To0Meta } from "/app/pages/subscription/buys/[id].vue?macro=true";
import { default as resultI8n1E7a7_45_9i_45r7HC_u0Y8cDMkf0bK0_ezykqDp3BgcMeta } from "/app/pages/subscription/buys/result.vue?macro=true";
import { default as index_nRhCL6pbL5RiOEU_45bGBmueLUQ7bdMSxK5_452gxYCZM4Meta } from "/app/pages/subscription/plans/index.vue?macro=true";
import { default as index5LUbIUjVqPc7QsFa8IXcfElbEUQ3DosRDk7G672TLvQMeta } from "/app/pages/api/gateway/callback/index.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "game",
    path: "/game",
    meta: gameQWAwGdPwtLsmyOCjoFmd2yqaforOOa9Vsw_nqU66qYoMeta || {},
    component: () => import("/app/pages/game.vue")
  },
  {
    name: "play",
    path: "/play",
    meta: playgEcQZxWhDCSvLKiTlDUGrDrCPPh74OLQdl5yO4M2w4wMeta || {},
    component: () => import("/app/pages/play.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: account8qjjsMH2Z_4583nGmUzgn0GenZn4EgfKFuzSOEohZZlYkMeta || {},
    component: () => import("/app/pages/account.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta || {},
    component: () => import("/app/pages/profile.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/app/pages/about-us.vue")
  },
  {
    name: "my-video",
    path: "/my-video",
    meta: my_45video6jtiIz29PdPWBmi_48X_45Xm313VAScr2zmJHlugvI0foMeta || {},
    component: () => import("/app/pages/my-video.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "bookmarks",
    path: "/bookmarks",
    component: () => import("/app/pages/bookmarks.vue")
  },
  {
    name: "episodes-id",
    path: "/episodes/:id()",
    meta: _91id_93EyupXKGFR7HQ7rpQDTt0POBBcvsP8E5qU6_tFprmtyIMeta || {},
    component: () => import("/app/pages/episodes/[id].vue")
  },
  {
    name: "biography-id",
    path: "/biography/:id()",
    component: () => import("/app/pages/biography/[id].vue")
  },
  {
    name: "categories-id",
    path: "/categories/:id()",
    component: () => import("/app/pages/categories/[id].vue")
  },
  {
    name: "categories",
    path: "/categories",
    component: () => import("/app/pages/categories/index.vue")
  },
  {
    name: "password-reset-enter",
    path: "/password/reset/enter",
    meta: enterWXKdFEabavhx8W9ilXXxSVXeEN_45W4_84oTiBl6z8p9oMeta || {},
    component: () => import("/app/pages/password/reset/enter.vue")
  },
  {
    name: "password-reset",
    path: "/password/reset",
    meta: indexNg5yhSiHRG0mEIOMAjGauMYoEfFsRiy8pNlacXHO2sYMeta || {},
    component: () => import("/app/pages/password/reset/index.vue")
  },
  {
    name: "password-reset-confirm",
    path: "/password/reset/confirm",
    meta: confirmbY1HL5oC6FT7xikJBIN8L9iCy9bPqydOlwygqi3jsn0Meta || {},
    component: () => import("/app/pages/password/reset/confirm.vue")
  },
  {
    name: "subscription-buys-id",
    path: "/subscription/buys/:id()",
    meta: _91id_93P9B7M8rFJxEInwupMlgARyZ_2lD9_l4lSejDiTJ6To0Meta || {},
    component: () => import("/app/pages/subscription/buys/[id].vue")
  },
  {
    name: "subscription-buys-result",
    path: "/subscription/buys/result",
    component: () => import("/app/pages/subscription/buys/result.vue")
  },
  {
    name: "subscription-plans",
    path: "/subscription/plans",
    component: () => import("/app/pages/subscription/plans/index.vue")
  },
  {
    name: "api-gateway-callback",
    path: "/api/gateway/callback",
    component: () => import("/app/pages/api/gateway/callback/index.vue")
  }
]